import { createSelector } from 'reselect';
import { RootState } from '../configureStore';

// Base selector
const getClientCredentialsState = (state: RootState) => state.ClientCredentials;

// Get all credentials as an array
export const getAllCredentials = createSelector(
    [getClientCredentialsState],
    (state) => state.credentials
);

// Get credentials by ID
export const getCredentialById = (id: string) => createSelector(
    [getClientCredentialsState],
    (state) => state.credentials[0]
);

// Get current environment
export const getEnvironment = createSelector(
    [getClientCredentialsState],
    (state) => state.environment
);

// Get search query
export const getSearchQuery = createSelector(
    [getClientCredentialsState],
    (state) => state.searchQuery
);

// Get current cursor
export const getCursor = createSelector(
    [getClientCredentialsState],
    (state) => state.cursor
);

// Get page size
export const getPageSize = createSelector(
    [getClientCredentialsState],
    (state) => state.pageSize
);

// Has next page
export const getHasNextPage = createSelector(
    [getClientCredentialsState],
    (state) => state.hasNextPage
);

// Has previous page
export const getHasPrevPage = createSelector(
    [getClientCredentialsState],
    (state) => state.hasPrevPage
);

// Get active tab
export const getActiveTab = createSelector(
    [getClientCredentialsState],
    (state) => state.activeTab
);

// Get loading state
export const getLoading = createSelector(
    [getClientCredentialsState],
    (state) => state.loading
);

// Get error
export const getError = createSelector(
    [getClientCredentialsState],
    (state) => state.error
);

// Get correlation ID
export const getCorrelationId = createSelector(
    [getClientCredentialsState],
    (state) => state.correlationId
);

// Check if there are any credentials
export const hasCredentials = createSelector(
    [getAllCredentials],
    (credentials) => credentials.length > 0
);

// Get filtered credentials count
export const getFilteredCredentialsCount = createSelector(
    [getAllCredentials],
    (credentials) => credentials.length
);
